// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__mINqG","wrapper":"Badge_wrapper__qcwm2","icon":"Badge_icon__71NP9","circle":"Badge_circle__XCObg"};